export const openImageViewer = (data) => ({
  type: "OPEN_IMAGE_VIEWER",
  payload: data,
});

export const closeImageViewer = () => ({
  type: "CLOSE_IMAGE_VIEWER",
});
